import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import GridContainer from '../../../../containers/GridContainer';
import './endpointgrid.scss';

class EndpointGridComponent extends React.Component {
    ENDPOINT_GRID_PROPS = [
        {
            title: 'Method',
            className: 'endpoint-method',
            getter: ({ method }) => <Button className={`${method}-button no-click`}>{method}</Button>,
        },
        {
            title: 'Endpoint-Description',
            className: 'endpoint-url',
            getter: ({ url, description }) => <a><b>{url}</b>&emsp;{description}</a>,
        },
    ]

    render() {
        const { apiObject } = this.props;
        let gridProps = this.ENDPOINT_GRID_PROPS;

        return <GridContainer
            className="endpoint-grid"
            name={`${apiObject.description}-endpoint-grid`}
            gridProps={gridProps}
            items={[
                {
                    method: apiObject.method,
                    url: apiObject.url,
                    description: apiObject.description,
                },
            ]}
        />;
    }
}

EndpointGridComponent.propTypes = {
    apiObject: PropTypes.object.isRequired,
};

export default EndpointGridComponent;



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/Compatibility/EndpointGridComponent.js